import React from "react";
import "./ScoreBoard.css";

const ScoreBoard = ({ scoreBoard, eventType }) => {
  if (!scoreBoard || Number(eventType) !== 4) {
    return null;
  }

  const {
    spnnation1 = "",
    spnnation2 = "",
    score1 = "",
    score2 = "",
    spnrunrate1 = "",
    spnrunrate2 = "",
    balls = [],
  } = scoreBoard;

  const renderScore = (score, runRate) => {
    if (!score && !runRate) return null;

    return (
      <span className="live-score-value">
        {score}

        {runRate && (
          <span className="live-score-crr">
            CRR {runRate}
          </span>
        )}
      </span>
    );
  };

  const getBallClass = (ball) => {
    const value = String(ball ?? "").trim().toLowerCase();

    if (value === "w" || value === "ww") {
      return "live-ball live-ball-wicket";
    }

    return "live-ball live-ball-normal";
  };

  return (
    <div className="live-scoreboard"

      style={{
        backgroundImage: `
      linear-gradient(
        rgba(0, 30, 12, 0.55),
        rgba(0, 30, 12, 0.55)
      ),
      url("${process.env.PUBLIC_URL}/Images/scorecard-bg.png")
    `,
      }}
    >
      <div className="live-score-team live-score-team-one">
        {spnnation1}
      </div>

      <div className="live-score-team live-score-team-two">
        {spnnation2}
      </div>

      <div className="live-score-number live-score-number-one">
        {renderScore(score1, spnrunrate1)}
      </div>

      <div className="live-score-number live-score-number-two">
        {renderScore(score2, spnrunrate2)}
      </div>

      <div className="live-score-balls">
        {(Array.isArray(balls) ? balls : []).map((ball, index) => (
          <span
            key={`${String(ball)}-${index}`}
            className={getBallClass(ball)}
          >
            {String(ball).toUpperCase()}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ScoreBoard;